import _ from 'lodash';
import { connect } from 'react-redux';
import { get, update, add, send, publicGet, getEmailInfo, invalidate} from '../../modules/accounting/trueUpInvoice';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let trueUpInvoice;
	let trueUpInvoiceId;

	if (ownProps.trueUpInvoice) {
		trueUpInvoice = ownProps.trueUpInvoice;
	} else {
		trueUpInvoiceId = (ownProps.trueUpInvoiceId)
			? ownProps.trueUpInvoiceId
			: _.get(ownProps, ['match', 'params', 'trueUpInvoiceId']);
		trueUpInvoice = _.get(state.maps, ['trueUpInvoice', trueUpInvoiceId]);
	}

	return {
		trueUpInvoice,
		bulkCustomerMap : state.maps.bulkCustomer,
		userMap : state.maps.user,
		resourceMap : state.maps.resource,
		quickbooksCustomerMap : state.maps.quickbooksCustomer,
		quickbooksTermMap : state.maps.quickbooksTerm,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getTrueUpInvoice : get,
	addTrueUpInvoice : add,
	updateTrueUpInvoice : update,
	sendTrueUpInvoice : send,
	publicGetTrueUpInvoice : publicGet,
	getTrueUpInvoiceEmailInfo : getEmailInfo,
	invalidateTrueUpInvoice : invalidate,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
